import { BUTTON } from '../constants';
import type { ButtonAttributes, ButtonElement } from '../types';

/** Create button element */
export const createButton = (attributes: ButtonAttributes): ButtonElement => {
    return { type: BUTTON, ...attributes, children: [{ text: '' }] };
};
